<div class="d-flex {{ props.horizontal ? '' : 'flex-column align-items-start justify-content-start' }}">
  @if (props.label && !props.hideLabel) {
    <label class="col-form-label d-flex text-nowrap" [attr.for]="id">
      {{ props.label }}
      @if (props.required) {
        *
      }
    </label>
  }
  <ng-template #fieldComponent></ng-template>
  @if (showError) {
    <div class="invalid-feedback d-block">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
</div>
